/* eslint-disable react/require-default-props */
import React from 'react';
import { Tooltip, Flex } from 'antd';
import { styled } from 'styled-components';
import { useDispatch } from 'react-redux';
import { useGlobals } from '../../globals-context';
import { changeLocation } from '../../actions';
import LogoShore from '../../assets/images/logos/logo_shore.svg';
import LogoShoreMark from '../../assets/images/logos/logo_shore_figurative_mark.svg';

interface SidebarLogoProps {
  collapsed: boolean;
  onLogoClick?: () => void;
}

const StyledLogoHeader = styled(Flex)<{ $collapsed: boolean }>`
  height: 64px;
  padding: 0;
  cursor: pointer;
  transition: all 150ms ease-in-out;
  user-select: none;

  &:hover {
    background: rgba(0, 0, 0, 0.02);
  }

  &:focus-visible {
    outline: 2px solid #00c2d1;
    outline-offset: -2px;
  }

  &:active {
    background: rgba(0, 0, 0, 0.04);
  }
`;

const StyledLogoIcon = styled(LogoShore)<{ $collapsed: boolean }>`
  width: ${({ $collapsed }) => ($collapsed ? '32px' : '123px')};
  height: ${({ $collapsed }) => ($collapsed ? '32px' : '24px')};
  flex-shrink: 0;
  transition:
    width 200ms ease-in-out,
    height 200ms ease-in-out;
  display: ${({ $collapsed }) => ($collapsed ? 'none' : 'block')};
`;

const StyledLogoMark = styled(LogoShoreMark)<{ $collapsed: boolean }>`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: ${({ $collapsed }) => ($collapsed ? 'block' : 'none')};
`;

export function SidebarLogo({ collapsed, onLogoClick }: SidebarLogoProps) {
  const dispatch = useDispatch();
  const { trackMethod } = useGlobals() as any;

  const handleOnClick = () => {
    if (onLogoClick) {
      onLogoClick();
    } else {
      dispatch(changeLocation('/calendar'));
      trackMethod('side_menu_logo_clicked', {
        platform: 'booking',
        location: 'side_menu',
      });
    }
  };

  const handleOnKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleOnClick();
      trackMethod('side_menu_logo_clicked', {
        platform: 'booking',
        location: 'side_menu',
      });
    }
  };

  const logoContent = (
    <StyledLogoHeader
      align="center"
      justify="center"
      $collapsed={collapsed}
      onClick={handleOnClick}
      onKeyDown={handleOnKeyDown}
      role="button"
      tabIndex={0}
      aria-label="Shore - Go to home"
    >
      <StyledLogoIcon $collapsed={collapsed} />
      <StyledLogoMark $collapsed={collapsed} />
    </StyledLogoHeader>
  );

  if (collapsed) {
    return (
      <Tooltip title="shore" placement="right">
        {logoContent}
      </Tooltip>
    );
  }

  return logoContent;
}
